module.exports = __webpack_public_path__ + "static/media/category16.0add8421.png";